import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

const StatsStrip = ({ items }) => (
  <Box sx={{ mt: { xs: -3, md: -5 }, position: "relative", zIndex: 2 }}>
    <Container>
      <Box
        sx={{
          borderRadius: "var(--radius-panel)",
          color: "#fff",
          background:
            "linear-gradient(135deg, rgba(12,22,36,0.98) 0%, rgba(19,33,52,0.96) 52%, rgba(30,45,67,0.94) 100%)",
          boxShadow: "var(--shadow-hero)",
          border: "1px solid rgba(255,255,255,0.08)",
          p: { xs: 2.7, md: 3.2, lg: 3.65 },
          overflow: "hidden",
        }}
      >
        <Grid container spacing={{ xs: 2.5, md: 3 }} sx={{ width: "100%", m: 0 }}>
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={item.label}>
              <Box
                sx={{
                  height: "100%",
                  pl: { md: index === 0 ? 0 : 2 },
                  borderLeft: {
                    md: index === 0 ? "none" : "1px solid rgba(255,255,255,0.09)",
                  },
                }}
              >
              <Typography variant="h3" sx={{ color: "primary.light", fontSize: { xs: "2rem", md: "2.45rem" } }}>
                {item.value}
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.75, color: "rgba(255,255,255,0.72)" }}>
                {item.label}
              </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  </Box>
);

export default StatsStrip;
